import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Tag } from "primereact/tag";
import Sidebar from "../Sidebar/Sidebar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import "./Representative.css";
import { Row, Col } from "react-bootstrap";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Calendar } from "primereact/calendar";
import { useHistory } from "react-router-dom";
import moment from "moment";
import {
  setUserSessionAuthKey,
  previewPdf,
  validateEmail
} from "../../Component/commonUtils";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { setupLocales } from "../../Component/setupLocales";
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from "primereact/fieldset";
import { ProgressSpinner } from "primereact/progressspinner";
import PreviewPdfHeader from "../../Component/PreviewPdf/previewPdfHeader";
import NoAccess from "../../Component/NoAccess/NoAccess";

let userSelectedLanguage = localStorage.getItem("selectedLanguage");
let tourGuidePages = localStorage.getItem("tourGuidePages");
let currentPageTourGuideName = "Representative";

let possibleAccessablePagesListLSArray = [];

let totalRepList = [];
let cityName = "";
let currentReportGUIDFromUrl = "",
  sideBarGreenTickPages = [],
  linkSharedUser,
  localeLang = "",
  paymentEntryNo,
  reportIDToGet = "",
  pdfLink = "";
let updateOnBlurFName = "",
  updateOnBlurLName = "";
let dataKeyIn = "",
  dateValue = "",
  unixTimestamp = "";

let localObject = "";
let userSessionAuthKeyReturnValue = setUserSessionAuthKey();

let steps = [
  {
    content: TranslationFile.TourGuide_Add_NewRep_Btn[userSelectedLanguage],
    placement: "top",
    styles: {
      options: {
        width: 300
      }
    },
    target: "#rep_addRep",
    title: TranslationFile.repAddRep[userSelectedLanguage],
    disableBeacon: true
  },

  {
    content:
      TranslationFile.TourGuide_Add_CheckBox_Delete_Btn[userSelectedLanguage],
    placement: "top",
    styles: {
      options: {
        width: 300
      }
    },
    target: ".whole-delete",
    title: TranslationFile.repDeleteBtn[userSelectedLanguage],
    disableBeacon: true
  }
];

export default function Representative() {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const history = useHistory();

  const signTypeObj = [
    { name: TranslationFile.repPaper[userSelectedLanguage], code: 0 },
    {
      name: TranslationFile.repDigitalSignature[userSelectedLanguage],
      code: 1
    }
  ];

  const [signTypeOptions] = useState([
    TranslationFile.repPaper[userSelectedLanguage],
    TranslationFile.repDigitalSignature[userSelectedLanguage]
  ]);
  const [reRender, setReRender] = useState(false);

  const witnessRepRole = [
    { name: "Likvidator", code: "Likvidator" },
    { name: "Likvidatorssuppleant", code: "Likvidatorssuppleant" },
    { name: "Styrelsesuppleant", code: "Styrelsesuppleant" },
    { name: "Styrelseledamot", code: "Styrelseledamot" },
    { name: "Verkställande direktör", code: "Verkställande direktör" }
  ];

  const witnessRepRoleNames = [
    "Likvidator",
    "Likvidatorssuppleant",
    "Styrelsesuppleant",
    "Styrelseledamot",
    "Verkställande direktör"
  ];

  const repRoleOptionsObj = [
    { name: "Aktuarie", code: "aktuarie" },
    { name: "Bolagsman", code: "bolagsman" },
    { name: "Delgivningsbar Person", code: "delgivningsbar person" },
    { name: "Extern Firmatecknare", code: "extern firmatecknare" },
    {
      name: "Extern Verkställande Direktör",
      code: "extern verkställande direktör"
    },
    {
      name: "Extern Vice Verkställande Direktör",
      code: "extern vice verkställande direktör"
    },
    { name: "Föreståndare", code: "föreståndare" },
    { name: "Huvudansvarig Revisor", code: "huvudansvarig revisor" },
    { name: "Innehavare", code: "innehavare" },
    { name: "Kommanditdelägare", code: "kommanditdelägare" },

    { name: "Komplementär", code: "komplementär" },
    { name: "Lekmannarevisor", code: "lekmannarevisor" },
    { name: "Lekmannarevisorssuppleant", code: "lekmannarevisorssuppleant" },
    { name: "Likvidator", code: "Likvidator" },
    { name: "Likvidatorssuppleant", code: "likvidatorssuppleant" },
    { name: "Ordförande", code: "ordförande" },
    { name: "Prokurist", code: "prokurist" },
    { name: "Revisor", code: "revisor" },
    { name: "Revisorssuppleant", code: "revisorssuppleant" },
    { name: "Styrelsesuppleant", code: "styrelsesuppleant" },
    { name: "Styrelseledamot", code: "styrelseledamot" },
    {
      name: "Ställföreträdande Verkställande Direktör",
      code: "ställföreträdande verkställande direktör"
    },
    { name: "Verkställande Direktör", code: "Verkställande direktör" },
    { name: "Verkställande Ledamot", code: "Verkställande Ledamot" },
    { name: "Vice Ordförande", code: "vice ordförande" },
    {
      name: "Vice Verkställande Direktör",
      code: "vice verkställande direktör"
    },
    { name: "Representant", code: "representant" },
    { name: "Revisor Hållbarhetsrapport", code: "revisor hållbarhetsrapport" },
    {
      name: "Revisorssuppleant Hållbarhetsrapport",
      code: "revisorssuppleant hållbarhetsrapport"
    },
    {
      name: "Huvudansvarig Revisor Hållbarhetsrapport",
      code: "huvudansvarig revisor hållbarhetsrapport"
    }
  ];

  const [repRoleOptions] = useState([
    "Aktuarie",
    "Bolagsman",
    "Delgivningsbar person",
    "Extern firmatecknare",
    "Extern verkställande direktör",
    "Extern vice verkställande direktör",
    "Föreståndare",
    "Huvudansvarig revisor",
    "Innehavare",
    "Kommanditdelägare",
    "Komplementär",
    "Lekmannarevisor",
    "Lekmannarevisorssuppleant",
    "Likvidator",

    "Likvidatorssuppleant",
    "Ordförande",
    "Prokurist",
    "Revisor",
    "Revisorssuppleant",
    "Styrelsesuppleant",
    "Styrelseledamot",
    "Ställföreträdande verkställande direktör",

    "Verkställande direktör",
    "Verkställande ledamot",
    "Vice ordförande",

    "Vice verkställande direktör",
    "Representant",
    "Revisor hållbarhetsrapport",

    "Revisorssuppleant hållbarhetsrapport",
    "Huvudansvarig revisor hållbarhetsrapport"
  ]);

  let emptyProduct = {
    firstName: "",
    lastName: "",
    socialSecurityNo: "",
    repRole: ""
  };

  const [companyName, setCompanyName] = useState("");
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [product, setProduct] = useState(null);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState([0, 1]);
  const [addNewRepDialog, setAddNewRepDialog] = useState(false);
  const [repFirstName, setRepFirstName] = useState("");
  const [repLastName, setRepLastName] = useState("");
  const [repSSN, setRepSSN] = useState("");
  const [repRole, setRepRole] = useState("");
  const [signType, setSignType] = useState(signTypeObj[0]);
  const [newRepsubmitted, setNewRepSubmitted] = useState(false);
  const [cityValue, setCityValue] = useState("");
  const [repDate, setRepDate] = useState(new Date());
  const [deleteRep, setDeleteRep] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [sideBarStatus, setSideBarStatus] = useState(true);
  const [reportAccess, setReportAccess] = useState(null);
  const [run, setRun] = useState(false);
  const [calendarHardCodedDate, setCalendarHardCodedDate] = useState("");
  const currentPageTourGuideName = "Representative";
  const [render, setRender] = useState(false);
  const [annualReportHeader, setAnnualReportHeader] = useState(null);
  const [fetchRepFromBolagsverketLoading, setFetchRepFromBolagsverketLoading] =
    useState(null);
  let [totalRepListArray, setTotalRepListArray] = useState("");
  let [reportIDFromDB, setReportIDFromDB] = useState("");

  const [repFirstNameBlurError, setRepFirstNameBlurError] = useState(false);
  const [repLastNameBlurError, setRepLastNameBlurError] = useState(false);
  const [repSsnBlurError, setRepSsnBlurError] = useState(false);
  const [witnessRep, setWitnessRep] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [isInvalid, setIsInvalid] = useState(false);
  const [witnessRoleDialogBox, setWitnessRoleDialogBox] = useState(false);
  const [selectedWitnessRole, setSelectedWitnessRole] = useState(null);
  const [selectedWrongWitness, setSelectedWrongWitness] = useState(null);
  const [emailError, setEmailError] = useState("");

  const [accessLevel, setAccessLevel] = useState(0);

  const sessionDetails = useSelector((state) => state.sessionDetails);
  const sideBarReducer = useSelector(
    (state) => state.sideBarReducer.sideBarReducer
  );
  const loginReducer = useSelector((state) => state.login);

  function accordionToggle(toggleOpen) {
    if (toggleOpen == true) {
      setActiveIndex([0, 1]);
      setToggleOpen(false);
    } else {
      setActiveIndex([2]);
      setToggleOpen(true);
    }
  }

  const roleEditOnChange = (e, options) => {
    options.rowData.role = e;
  };

  const previewPdfLocal = (currentReportGUIDFromUrl) => {
    setPdfLoading(true);
    setTimeout(() => {
      let pdfReturn = previewPdf(currentReportGUIDFromUrl);
      setPdfLoading(!pdfReturn);
    }, 500);
  };

  const signTypeEditOnChange = (e, options) => {
    if (
      e == TranslationFile.repDigitalSignature[userSelectedLanguage] &&
      options.rowData.sSN != ""
    ) {
      options.rowData.signType = e;
    } else if (e == TranslationFile.repPaper[userSelectedLanguage]) {
      options.rowData.signType = e;
    } else {
      toast.current.show({
        severity: "error",
        summary: TranslationFile.errorText[userSelectedLanguage],
        detail: (
          <>
            {TranslationFile.repToast1[userSelectedLanguage]}{" "}
            <b>{TranslationFile.repDigitalSignature[userSelectedLanguage]}</b>
          </>
        ),

        life: 6000
      });
    }
  };

  const roleEditOnBlur = (e, options) => {
    representativeInputOnBlur(e, "role", options);
  };

  const signTypeEditOnBlur = (e, options) => {
    representativeInputOnBlur(e, "signType", options);
  };

  const roleEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        // editable
        options={options.rowData.witness ? witnessRepRoleNames : repRoleOptions}
        onChange={(e) => roleEditOnChange(e.target.value, options)}
        onBlur={(e) => roleEditOnBlur(e, options.rowData)}
        placeholder={TranslationFile.SelectAStatusText[userSelectedLanguage]}
        itemTemplate={(option) => {
          return <Tag value={option}></Tag>;
        }}
      />
    );
  };

  const signTypeEditor = (options) => {
    let signType = TranslationFile.repPaper[userSelectedLanguage];
    if (options.value > 0)
      signType = TranslationFile.repDigitalSignature[userSelectedLanguage];
    return (
      <Dropdown
        value={signType}
        // editable
        className="signTypeEditDropdown"
        options={signTypeOptions}
        onChange={(e) => signTypeEditOnChange(e.target.value, options)}
        onBlur={(e) => signTypeEditOnBlur(e, options.rowData)}
        placeholder={TranslationFile.SelectASignTypeText[userSelectedLanguage]}
        itemTemplate={(option) => {
          return <Tag value={option}></Tag>;
        }}
      />
    );
  };

  const isValidWitnessRoleCheck = (role) => {
    let isValidWitnessRole = false;

    witnessRepRole.map((witnessRole, witneddRoleIdx) => {
      if (witnessRole.name == role) return (isValidWitnessRole = true);
    });

    return isValidWitnessRole;
  };

  const pageNavigation = (navigateToPageName) => {
    //Check if the user(Report Owner) is logged in or not
    // if (reportAccess == 1) {
    let localData = localStorage.getItem("rebelSkoolUser");
    localObject = localData && JSON.parse(localData);
    if (localObject["userName"] == undefined) {
      document.getElementsByClassName("user-btn")[0].click();
    } else {
      let sideBarReducerValues = [];
      sideBarReducerValues = sideBarReducer.values;

      sideBarReducer.values = sideBarReducerValues;
      let possibleAccessablePagesListLSString = localStorage.getItem(
        "possibleAccessablePages"
      );
      possibleAccessablePagesListLSArray = JSON.parse(
        possibleAccessablePagesListLSString
      );
      if (!possibleAccessablePagesListLSArray.includes("Payment")) {
        possibleAccessablePagesListLSArray.push(
          "Company Information",
          "Income Statement",
          "Balance Sheet",
          "Notes",
          "Management Statement"
          //"Payment"
        );

        possibleAccessablePagesListLSArray = [
          ...new Set(possibleAccessablePagesListLSArray)
        ];
        let updatePossibleNavigationPagesListString = JSON.stringify(
          possibleAccessablePagesListLSArray
        );

        localStorage.setItem(
          "possibleAccessablePages",
          updatePossibleNavigationPagesListString
        );
      }
      history.push("Payment");
    }
    //If the user already paid for the report, we should navigate him directly to the Review and send page
    if (paymentEntryNo > 0) {
      // history.push("reviewAndSend");
      history.push("Payment");
      //digitalSignature
    }
    // } else {
    //If he is not the Report Owner, we should navigate him directly to the Review and send page
    // history.push("reviewAndSend");
    //   history.push("reviewAndSend");
    // }
  };
  const checkverified =
    witnessRep !== undefined &&
    witnessRep?.ssn !== undefined &&
    witnessRep?.ssn?.trim() !== "" &&
    witnessRep?.emailId !== undefined &&
    witnessRep?.emailId?.trim() !== "" &&
    witnessRep?.firstName !== undefined &&
    witnessRep?.firstName?.trim() !== "" &&
    witnessRep?.lastName !== undefined &&
    witnessRep?.lastName?.trim() !== "" &&
    cityValue !== undefined &&
    cityValue?.trim() !== "" &&
    repDate !== undefined &&
    repDate !== null &&
    repDate !== "";
  const bankIdOnClick = () => {
    history.push("bankId");
  };

  const navigationOnClick = (navigateToPageName) => {
    if (navigateToPageName == "managementStatement") {
      history.push(navigateToPageName);
      return;
    } else {
      //If the user wants to navigate to next page
      // Check if the user filled all the mandatory fields
      let repWithSSN = totalRepList.filter((obj) => obj.sSN != "");
      if (totalRepList.length == 0) {
        toast.current.show({
          severity: "error",
          summary: TranslationFile.errorText[userSelectedLanguage],
          detail: TranslationFile.repToast2[userSelectedLanguage],
          life: 3000
        });
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }, 100);
      } else if (totalRepList.length > 1 && repWithSSN.length == 0) {
        toast.current.show({
          severity: "warn",
          summary: TranslationFile.balanceSheetWarningTag[userSelectedLanguage],
          detail: TranslationFile.repToast3[userSelectedLanguage],
          life: 3000
        });
      } else if (cityValue == "" || repDate == "") {
        toast.current.show({
          severity: "error",
          summary: TranslationFile.errorText[userSelectedLanguage],
          detail: TranslationFile.repToast4[userSelectedLanguage],
          life: 3000
        });
      } else if (
        totalRepList.length === 1 &&
        cityValue !== "" &&
        repDate !== ""
      ) {
        if (witnessRep !== undefined) {
          if (witnessRep.ssn !== "") {
            if (witnessRep.emailId === undefined || witnessRep.emailId === "") {
              toast.current.show({
                severity: "error",
                summary: TranslationFile.errorText[userSelectedLanguage],
                detail: (
                  <>
                    {
                      TranslationFile.PleaseEnterEmailAdd[userSelectedLanguage]
                    }{" "}
                  </>
                ),
                life: 6000
              });
            } else pageNavigation(navigateToPageName);
          } else {
            toast.current.show({
              severity: "error",
              summary: TranslationFile.errorText[userSelectedLanguage],
              detail: (
                <>
                  {
                    TranslationFile.repWitnessSSNMissing[userSelectedLanguage]
                  }{" "}
                </>
              ),

              life: 6000
            });
          }
        } else {
          setIsInvalid(true);
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          toast.current.show({
            severity: "warn",
            summary: TranslationFile.warnText[userSelectedLanguage],
            detail: TranslationFile.repSelectWitness[userSelectedLanguage],
            life: 6000
          });
        }
      } else if (
        totalRepList.length > 1 &&
        repWithSSN.length >= 1 &&
        cityValue != "" &&
        repDate !== ""
      ) {
        if (
          witnessRep != undefined &&
          witnessRep.firstName != undefined &&
          witnessRep.lastName != undefined
        ) {
          if (witnessRep.ssn != "" && witnessRep.emailId != "") {
            pageNavigation(navigateToPageName);
          } else {
            if (witnessRep.ssn != "") {
              toast.current.show({
                severity: "error",
                summary: TranslationFile.errorText[userSelectedLanguage],
                detail: (
                  <>
                    {
                      TranslationFile.repWitnessSSNMissing[userSelectedLanguage]
                    }{" "}
                  </>
                ),

                life: 6000
              });
            } else {
              toast.current.show({
                severity: "error",
                summary: TranslationFile.errorText[userSelectedLanguage],
                detail: (
                  <>
                    {
                      TranslationFile.PleaseEnterEmailAdd[userSelectedLanguage]
                    }{" "}
                  </>
                ),

                life: 6000
              });
            }
          }
        } else {
          setIsInvalid(true);
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          toast.current.show({
            severity: "warn",
            summary: TranslationFile.warnText[userSelectedLanguage],
            detail: TranslationFile.repSelectWitness[userSelectedLanguage],
            life: 6000
          });
        }
      }
    }

    let repWithSSN = totalRepList.filter((obj) => obj.sSN != "");

    if (totalRepList.length == 0) {
      toast.current.show({
        severity: "error",
        summary: TranslationFile.errorText[userSelectedLanguage],
        detail: TranslationFile.repToast2[userSelectedLanguage],
        life: 3000
      });
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      return;
    }

    if (totalRepList.length > 1 && repWithSSN.length == 0) {
      toast.current.show({
        severity: "warn",
        summary: TranslationFile.balanceSheetWarningTag[userSelectedLanguage],
        detail: TranslationFile.repToast3[userSelectedLanguage],
        life: 3000
      });
      return;
    }

    if (cityValue == "" || repDate == "" || repDate == null) {
      toast.current.show({
        severity: "error",
        summary: TranslationFile.errorText[userSelectedLanguage],
        detail: TranslationFile.repToast4[userSelectedLanguage],
        life: 3000
      });
      return;
    }

    // STRICT CHECK FOR WITNESS: Ensure a witness is completely selected and valid
    if (
      witnessRep == undefined ||
      witnessRep === "" ||
      !witnessRep.witness ||
      !witnessRep.firstName ||
      !witnessRep.lastName ||
      !witnessRep.ssn
    ) {
      setIsInvalid(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      toast.current.show({
        severity: "warn",
        summary: TranslationFile.warnText[userSelectedLanguage],
        detail: TranslationFile.repSelectWitness[userSelectedLanguage],
        life: 6000
      });
      return;
    }

    // Check witness specific details once we know a witness row is selected
    if (witnessRep.emailId == undefined || witnessRep.emailId == "") {
      /*  toast.current.show({
        severity: "error",
        summary: TranslationFile.errorText[userSelectedLanguage],
        detail: TranslationFile.PleaseEnterEmailAdd[userSelectedLanguage],
        life: 6000
      });
      return; */
    }

    // Everything is verified, proceed to next page
    pageNavigation(navigateToPageName);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (userSelectedLanguage == "sw") {
      localeLang = "sv";
    } else if (userSelectedLanguage == "en") {
      localeLang = "en";
    }
    setupLocales(localeLang);
    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
    pdfLink = "#annualreport/" + currentReportGUIDFromUrl + "/pdf";
    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            setAnnualReportHeader(response.data);
            paymentEntryNo = response.data.paymentEntryNo;

            let responseDate = response.data;
            let witnessEmailFromHeader = responseDate.witnessEmailId;
            cityName = response.data.city;
            // setCityValue(response.data.city)

            if (responseDate != "") {
              let reportAccessReq = {
                reportId: responseDate.reportID
              };
              axios
                .post(
                  "/annualReport/getAccessStatus",
                  reportAccessReq,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  switch (response.data) {
                    case 1:
                      linkSharedUser = 1; //Write
                      setReportAccess(1);
                      break;
                    case 2:
                      linkSharedUser = 2; //Write
                      setReportAccess(2);
                      break;
                    case 3:
                      linkSharedUser = 3; //Read Only
                      setReportAccess(3);
                      break;
                    case 4:
                      linkSharedUser = 4; //No Access
                      setReportAccess(4);
                      break;
                  }

                  setAccessLevel(linkSharedUser);
                })
                .catch((error) => {
                  setAccessLevel(error.response.data);
                });
            }
            // }

            axios
              .get(
                "/annualReport/getCompletedPages?reportId=" +
                  response.data.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((completedStatementTypesResponse) => {
                sideBarReducer.values = completedStatementTypesResponse.data;
                sideBarGreenTickPages = completedStatementTypesResponse.data;
              });
            checkAccessablePages();
            // Get Representative API
            axios
              .get(
                "/annualReportRepresentative/getByReportId?reportID=" +
                  response.data.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                setPageLoading(false);
                if (response.data.length > 0) {
                  totalRepList = response.data;
                  setTotalRepListArray(response.data);
                  if (
                    response.data[0].city != "" &&
                    response.data[0].city != null
                  ) {
                    setCityValue(response.data[0].city);
                  } else {
                    setCityValue(cityName);
                  }

                  let dateFromDB = response.data[0].date;
                  if (dateFromDB && dateFromDB.length > 0) {
                    let convertedDate = new Date(dateFromDB);
                    setRepDate(convertedDate);
                  }
                  checkForGreenTick(response.data);

                  let witnessResultObj = totalRepList.filter(
                    (i) => i.witness == true
                  )[0];

                  let localData = localStorage.getItem("rebelSkoolUser");
                  localObject = localData && JSON.parse(localData);

                  // this.setState({ witness: localObject.emailID });

                  if (witnessResultObj != undefined)
                    if (
                      witnessEmailFromHeader == "" ||
                      witnessEmailFromHeader == null
                    ) {
                      witnessResultObj.emailId = localObject.emailID;
                    } else {
                      witnessResultObj.emailId = witnessEmailFromHeader;
                    }

                  setWitnessRep(witnessResultObj);
                } else {
                  setCityValue(cityName);
                }
              });
          }
          setReportIDFromDB(response.data.reportID);
          setCompanyName(response.data.companyName);
          setCurrentFinancialYear(response.data.currentYear);
        });
    }

    // const timer = setTimeout(() => {
    //   let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;
    //   setRun(userTourGuide);
    // }, 200);

    // return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;
    let tourGuidePages =
      JSON.parse(localStorage.getItem("tourGuidePages")) || [];

    if (userTourGuide) {
      if (tourGuidePages.includes(currentPageTourGuideName)) {
        setTimeout(() => {
          setRun(false);
        }, 200);
      } else {
        setTimeout(() => {
          setRun(true);
        }, 200);
      }
    }

    // Update tourGuidePages in localStorage
    if (!tourGuidePages.includes(currentPageTourGuideName)) {
      tourGuidePages.push(currentPageTourGuideName);
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    }
  }, [currentPageTourGuideName]);

  const roleBodyTemplate = (rowData) => {
    return <Tag value={rowData.role}></Tag>;
  };

  const signTypeBodyTemplate = (rowData) => {
    let signType = TranslationFile.repPaper[userSelectedLanguage];
    if (rowData.signType > 0)
      signType = TranslationFile.repDigitalSignature[userSelectedLanguage];
    return <Tag value={signType}></Tag>;
  };

  const navigateToPDF = () => {
    window.open(`/annualreport/${currentReportGUIDFromUrl}/pdf`, "_blank");
  };

  const witnessDropdownOnClick = (e) => {
    setSelectedWitnessRole(e);

    let currentWitness = [];
    currentWitness = totalRepList.filter((i) => i.witness);
    if (currentWitness.length) {
      currentWitness[0].witness = false;
    }

    let filterSelectedWitnessFromList = totalRepList.filter(
      (i) => i.no == selectedWrongWitness.no
    )[0];
    filterSelectedWitnessFromList.role = e.code;
    filterSelectedWitnessFromList.witness = true;

    let localData = localStorage.getItem("rebelSkoolUser");
    localObject = localData && JSON.parse(localData);

    filterSelectedWitnessFromList.emailId = localObject.emailID;
    setWitnessRep(filterSelectedWitnessFromList);
    setWitnessRoleDialogBox(false);

    axios
      .post(
        "/annualReportRepresentative/updateList",
        totalRepList,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        if (response.data) {
        }
      });
  };

  const checkForGreenTick = (repListParamter) => {
    let possibleAccessablePagesListLSString = localStorage.getItem(
      "possibleAccessablePages"
    );
    let possibleAccessablePagesListLSArray = JSON.parse(
      possibleAccessablePagesListLSString
    );

    if (checkverified) {
      if (
        possibleAccessablePagesListLSArray != null &&
        // && !possibleAccessablePagesListLSArray.includes("Representative")
        repListParamter.length > 0
      ) {
        possibleAccessablePagesListLSArray.push(
          "Company Information",
          "Income Statement",
          "Balance Sheet",
          "Notes",
          "Management Statement",
          "Representative"
        );

        possibleAccessablePagesListLSArray = [
          ...new Set(possibleAccessablePagesListLSArray)
        ];
        let updatePossibleNavigationPagesListString = JSON.stringify(
          possibleAccessablePagesListLSArray
        );

        localStorage.setItem(
          "possibleAccessablePages",
          updatePossibleNavigationPagesListString
        );
      }
      setReRender(true);
    } else {
      checkAccessablePages();
    }
  };
  useEffect(() => {
    checkForGreenTick(totalRepList);
  }, [checkverified]);
  const witnessOnClick = (e, rowData) => {
    let isValidWitnessRole = isValidWitnessRoleCheck(rowData.role);
    setSelectedWrongWitness(rowData);

    if (rowData.ssn == null || rowData.ssn == "") {
      toast.current.show({
        severity: "error",
        detail: TranslationFile.repSsnReq[userSelectedLanguage],

        life: 3000
      });
    } else {
      if (isValidWitnessRole) {
        rowData.witness = e.checked;
        if (witnessRep != undefined) {
          if (witnessRep.emailId == "" || witnessRep.emailId == null) {
            let localData = localStorage.getItem("rebelSkoolUser");
            localObject = localData && JSON.parse(localData);

            rowData.emailId = localObject.emailID;
          } else {
            rowData.emailId = witnessRep.emailId;
          }
        } else {
          let localData = localStorage.getItem("rebelSkoolUser");
          localObject = localData && JSON.parse(localData);

          rowData.emailId = localObject.emailID;
        }

        setWitnessRep(rowData);

        totalRepList
          .filter((i) => i.no !== rowData.no)
          .forEach((i) => {
            i.witness = false;
          });

        totalRepList
          .filter((i) => i.no === rowData.no)
          .forEach((i) => {
            i.witness = true;
          });

        // if (isValidWitnessRole) {
        axios
          .post(
            "/annualReportRepresentative/updateList",
            totalRepList,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
            }
          });

        let result = totalRepList.filter((i) => i.no === rowData.no)[0];

        result.city = cityValue;
        result.emailId = rowData.emailId;

        axios
          .post(
            "/annualReport/addWitness",
            result,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
            }
          });

        setReRender(!reRender);
        setWitnessRoleDialogBox(false);
      } else {
        setWitnessRoleDialogBox(true);
      }
    }
  };

  const witnessBodyTemplate = (rowData) => {
    // let signType = TranslationFile.repPaper[userSelectedLanguage];
    // if (rowData.signType > 0) signType = TranslationFile.repDigitalSignature[userSelectedLanguage];
    // return <Tag value={signType}></Tag>;

    return (
      <RadioButton
        inputId="ingredient1"
        name="pizza"
        value="true"
        onChange={(e) => {
          witnessOnClick(e, rowData);
          setIsInvalid(false);
        }}
        checked={rowData.witness === true}
        disabled={linkSharedUser == 3 ? true : false}
        invalid={isInvalid}
        className={isInvalid ? "p-invalid p-invalid-glow" : ""}
      />
    );
  };

  /**
   *
   * fucntion
   *
   * call:
   *  witness click when no error
   *  Email ID onBlur when there is emailId is written
   *  City onBlur when city is filled
   *
   * job: insert "Representative" in possibleAccessablePages
   * insert logic check: check witness is selected, city and date is filled,
   * then remaining all the mandatory fields are filled. then only we need to insert
   * "Representative" in possibleAccessablePages
   *
   * alse we need to remove "Representative" from possibleAccessablePages,
   * when any one of the mandatory fields are not filled or witness is not selected.
   * also when selected witness is deleted, then also we need to remove
   * "Representative" from possibleAccessablePages
   *
   * add * in Date
   *
   * also check date is filled or not
   *    *    *
   */
  const checkAccessablePages = () => {
    const isWitnessComplete =
      witnessRep != undefined &&
      witnessRep.witness === true &&
      witnessRep.ssn != undefined &&
      witnessRep?.ssn.trim() !== "" &&
      witnessRep.firstName != undefined &&
      witnessRep?.firstName.trim() !== "" &&
      witnessRep.lastName != undefined &&
      witnessRep?.lastName.trim() !== "" &&
      witnessRep.emailId != undefined &&
      witnessRep?.emailId.trim() !== "" &&
      validateEmail(witnessRep.emailId);

    const isCityFilled = cityValue != undefined && cityValue.trim() !== "";
    const isDateFilled =
      repDate != undefined && repDate !== null && repDate !== "";

    const allMandatoryFieldsFilled =
      isWitnessComplete && isCityFilled && isDateFilled;

    let possibleAccessablePagesListLSString = localStorage.getItem(
      "possibleAccessablePages"
    );
    let updatedList = JSON.parse(possibleAccessablePagesListLSString) || [];

    if (allMandatoryFieldsFilled) {
      if (!updatedList.includes("Representative")) {
        updatedList.push("Representative");
      }
    } else {
      if (updatedList.includes("Representative")) {
        updatedList = updatedList.filter((page) => page !== "Representative");
      }
    }

    updatedList = [...new Set(updatedList)];
    localStorage.setItem(
      "possibleAccessablePages",
      JSON.stringify(updatedList)
    );
  };
  const addNewRep = () => {
    if (userSessionAuthKeyReturnValue) {
      setNewRepSubmitted(true);
      setRepSsnBlurError(false);
      if (
        repFirstName != "" &&
        repLastName != "" &&
        repRole != "" &&
        signType != "" &&
        repFirstName.length > 1 &&
        repLastName.length > 1
      ) {
        let unixTimestamp = null;
        if (repDate != null) {
          let StandardDateFormat = moment(repDate).format("YYYY-MM-DD");

          const date = new Date(StandardDateFormat);
          unixTimestamp = Math.floor(date.getTime());
        }
        let insertRepToDB = {
          reportID: reportIDFromDB,
          firstName: repFirstName,
          lastName: repLastName,
          sSN: repSSN,
          role: repRole.name == undefined ? repRole : repRole.code,
          signType: signType.code,
          signStatus: 0,
          date: unixTimestamp
        };

        // Insert Representative API
        if ((signType.code == 1 && repSSN != "") || signType.code == 0) {
          axios
            .post(
              "/annualReportRepresentative/insert",
              insertRepToDB,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              if (response.data) {
                if (cityValue != "" && cityValue != null) {
                  CityOnBlur();
                }

                if (unixTimestamp != "" && unixTimestamp != null) {
                  let updateDateObject = {
                    date: unixTimestamp,
                    reportID: reportIDFromDB
                  };

                  // Insert & Update Representative Date
                  axios
                    .post(
                      "/annualReportRepresentative/updateDate",
                      updateDateObject,
                      userSessionAuthKeyReturnValue
                    )
                    .then((response) => {});
                }
                // Get Representative API
                axios
                  .get(
                    "/annualReportRepresentative/getByReportId?reportID=" +
                      reportIDFromDB,
                    userSessionAuthKeyReturnValue
                  )
                  .then((response) => {
                    totalRepList = response.data;

                    let witnessResultObj = totalRepList.filter(
                      (i) => i.witness == true
                    )[0];
                    setWitnessRep(witnessResultObj);

                    setTotalRepListArray(response.data);

                    toast.current.show({
                      severity: "success",
                      summary:
                        TranslationFile.SuccessfulText[userSelectedLanguage],
                      detail:
                        TranslationFile.RepAddSucess[userSelectedLanguage],
                      life: 3000
                    });
                    checkForGreenTick(response.data);
                  });

                setTotalRepListArray(totalRepList);
                setRepFirstName("");
                setRepLastName("");
                setRepSSN("");
                setRepRole("");
                setAddNewRepDialog(false);
                setNewRepSubmitted(false);
              } else {
                toast.current.show({
                  severity: "warn",
                  summary:
                    TranslationFile.balanceSheetWarningTag[
                      userSelectedLanguage
                    ],
                  detail: TranslationFile.repToast5[userSelectedLanguage],
                  life: 3000
                });
              }
            });
        }
      }
    }
  };

  const openNew = () => {
    setAddNewRepDialog(true);
    setNewRepSubmitted(false);
    setRepFirstName("");
    setRepLastName("");
    setRepSSN("");
    setRepRole("");
    // setRepRole(repRoleOptions[0]);
  };

  const fetchFromBolagsverket = () => {
    let insertRepByOrgNoReqObj = {
      reportGUID: currentReportGUIDFromUrl,
      companyName: "",
      registrationNo: annualReportHeader.registrationNo,
      postalCode: "",
      city: "",
      currentYear: "",
      previousYear1: "",
      previousYear2: "",
      previousYear3: "",
      createdByUserID: 0,
      fetchRepButton: true
    };

    setFetchRepFromBolagsverketLoading(true);
    axios
      .post(
        "/annualReportRepresentative/insertByOrgNo",
        insertRepByOrgNoReqObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        setFetchRepFromBolagsverketLoading(false);
        if (response.data) {
          axios
            .get(
              "/annualReportRepresentative/getByReportId?reportID=" +
                reportIDFromDB,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              totalRepList = response.data;

              let witnessResultObj = totalRepList.filter(
                (i) => i.witness == true
              )[0];
              setWitnessRep(witnessResultObj);

              setTotalRepListArray(response.data);

              toast.current.show({
                severity: "success",
                summary: TranslationFile.SuccessfulText[userSelectedLanguage],
                detail: TranslationFile.RepAddSucess[userSelectedLanguage],
                life: 3000
              });
              checkForGreenTick(response.data);
            });
        } else if (response.status == 204) {
          toast.current.show({
            severity: "warn",
            summary:
              TranslationFile.balanceSheetWarningTag[userSelectedLanguage],
            detail: TranslationFile.noRepFoundAtBolags[userSelectedLanguage],
            life: 3000
          });
        }
      });
  };

  const rightToolbarTemplate = () => {
    return (
      <>
        <div className="flex flex-wrap gap-2 ">
          {linkSharedUser != 3 ? (
            <>
              {fetchRepFromBolagsverketLoading ? (
                <Button className="fetchingButton" id="rep_fetchRep">
                  <>
                    <ProgressSpinner
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px"
                      }}
                      strokeWidth="8"
                      animationDuration=".5s"
                    />
                    <span style={{ marginLeft: "8px" }}>
                      {TranslationFile.repFetching[userSelectedLanguage]}
                    </span>
                  </>
                </Button>
              ) : (
                <Button
                  style={{ marginRight: "10px" }}
                  label={TranslationFile.repFetchingRep[userSelectedLanguage]}
                  id="rep_fetchRep"
                  icon="pi pi-cloud-download"
                  severity="info"
                  onClick={() => {
                    fetchFromBolagsverket();
                  }}
                  disabled={linkSharedUser == 3 && true}
                />
              )}
            </>
          ) : (
            ""
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          {linkSharedUser != 3 ? (
            <Button
              label={TranslationFile.repAddRep[userSelectedLanguage]}
              id="rep_addRep"
              icon="pi pi-plus"
              severity="success"
              onClick={openNew}
              disabled={linkSharedUser == 3 && true}
            />
          ) : (
            ""
          )}
        </div>
      </>
    );
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProductsDialog(false);
  };

  const confirmDeleteProduct = (rowData) => {
    setProduct(rowData);
    setDeleteProductDialog(true);
  };

  const confirmDeleteSelected = () => {
    setDeleteProductsDialog(true);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        {linkSharedUser != 3 ? (
          <Button
            className="whole-delete"
            label={TranslationFile.repDeleteBtn[userSelectedLanguage]}
            icon="pi pi-trash"
            severity="danger"
            onClick={confirmDeleteSelected}
            disabled={
              !selectedProducts || !selectedProducts.length || reportAccess == 3
            }
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  const hideAddNewRep = () => {
    setAddNewRepDialog(false);
    setNewRepSubmitted(false);
    setRepFirstName("");
    setRepLastName("");
    setRepSSN("");
    setRepRole("");
    // setRepRole(repRoleOptions[0]);
    setRepFirstNameBlurError(false);
    setRepLastNameBlurError(false);
    setRepSsnBlurError(false);
  };

  const addNewRepDialogFooter = (
    <React.Fragment>
      <Button
        label={TranslationFile.repCancelbtn[userSelectedLanguage]}
        icon="pi pi-times"
        outlined
        onClick={hideAddNewRep}
      />
      <Button
        label={TranslationFile.repSavebtn[userSelectedLanguage]}
        icon="pi pi-check"
        onClick={addNewRep}
      />
    </React.Fragment>
  );

  const onRowEditComplete = (rowData, fieldName) => {
    if (userSessionAuthKeyReturnValue) {
      let updateRepToDB = {
        firstName: rowData.firstName,
        lastName: rowData.lastName,
        sSN: rowData.sSN,
        role: rowData.role,
        reportID: reportIDFromDB,
        no: rowData.no,
        signType:
          rowData.signType == TranslationFile.repPaper[userSelectedLanguage] ||
          rowData.signType == 0
            ? 0
            : 1,
        witness: rowData.witness
      };

      axios
        .post(
          "/annualReportRepresentative/update",
          updateRepToDB,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            toast.current.show({
              severity: "success",
              summary: TranslationFile.SuccessfulText[userSelectedLanguage],
              detail: TranslationFile.RepUpdateSucess[userSelectedLanguage],
              life: 3000
            });
            axios
              .get(
                "/annualReportRepresentative/getByReportId?reportID=" +
                  reportIDFromDB,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                totalRepList = response.data;
                setTotalRepListArray(totalRepList);
                checkForGreenTick(totalRepList);

                let witnessResultObj = totalRepList.filter(
                  (i) => i.witness == true
                )[0];
                setWitnessRep(witnessResultObj);
              });
          }

          if (
            document.getElementsByClassName("p-row-editor-save p-link")[0] !=
            undefined
          ) {
            document
              .getElementsByClassName("p-row-editor-save p-link")[0]
              .click();
          }
        });
    }
  };
  const representativeInputOnBlur = (e, field, rowData) => {
    let getRepResponse = "";
    if (userSessionAuthKeyReturnValue) {
      if (field == "SSN" && rowData.signType == 1 && e.target.value == "") {
        toast.current.show({
          severity: "error",
          summary: TranslationFile.errorText[userSelectedLanguage],
          detail: (
            <>
              {TranslationFile.repToast6[userSelectedLanguage]}{" "}
              <b>{TranslationFile.repDigitalSignature[userSelectedLanguage]}</b>{" "}
              {TranslationFile.repToast7[userSelectedLanguage]}
            </>
          ),

          life: 6000
        });
      } else {
        axios
          .get(
            "/annualReportRepresentative/getByReportId?reportID=" +
              reportIDFromDB,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            getRepResponse = response.data;
            getRepResponse =
              getRepResponse &&
              getRepResponse.filter((res) => res.no == rowData.no);

            let witnessResultObj = totalRepList.filter(
              (i) => i.witness == true
            )[0];
            setWitnessRep(witnessResultObj);

            if (getRepResponse[0].firstName !== rowData.firstName) {
              onRowEditComplete(rowData, "firstName");
            } else if (getRepResponse[0].lastName !== rowData.lastName) {
              onRowEditComplete(rowData, "lastName");
            } else if (getRepResponse[0].sSN !== rowData.sSN) {
              onRowEditComplete(rowData, "sSN");
            } else if (getRepResponse[0].role !== rowData.role) {
              onRowEditComplete(rowData, "role");
            } else if (getRepResponse[0].signType !== rowData.signType) {
              onRowEditComplete(rowData, "signType");
            } else if (getRepResponse[0].witness !== rowData.witness) {
              onRowEditComplete(rowData, "witness");
            }

            if (field == "SSN") {
              let obj = {
                update: "ssn",
                value: rowData.sSN,
                reportGuid: currentReportGUIDFromUrl
              };

              axios
                .post(
                  "/annualReport/updateWitness",
                  obj,
                  userSessionAuthKeyReturnValue
                )

                .then((response) => {
                  if (response.data) {
                  }
                });
            }
          });
      }
    }
  };

  const textEditorFName = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onBlur={(e) => representativeInputOnBlur(e, "FName", options.rowData)}
      />
    );
  };
  const textEditorLName = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onBlur={(e) => representativeInputOnBlur(e, "LName", options.rowData)}
      />
    );
  };
  const textEditorMask = (options) => {
    return (
      <InputMask
        value={options.value}
        onChange={(e) => options.editorCallback(e.value)}
        useGrouping={false}
        mask="99999999-9999"
        onBlur={(e) => representativeInputOnBlur(e, "SSN", options.rowData)}
        // required
        placeholder={TranslationFile.SSNFormat[userSelectedLanguage]}
      />
    );
  };

  const deleteProduct = async () => {
    if (
      userSessionAuthKeyReturnValue &&
      selectedProducts &&
      selectedProducts.length > 0
    ) {
      setDeleteProductDialog(false);
      setDeleteProductsDialog(false);

      try {
        // Delete all selected items from database
        const deletePromises = selectedProducts.map((val) => {
          let deleteRepFromDB = {
            reportID: reportIDFromDB,
            no: val.no
          };
          return axios.post(
            "/annualReportRepresentative/delete",
            deleteRepFromDB,
            userSessionAuthKeyReturnValue
          );
        });

        await Promise.all(deletePromises);

        // Get the freshly updated list
        const response = await axios.get(
          "/annualReportRepresentative/getByReportId?reportID=" +
            reportIDFromDB,
          userSessionAuthKeyReturnValue
        );

        totalRepList = response.data;
        setTotalRepListArray(response.data);
        checkForGreenTick(response.data);

        // Look for a remaining witness
        let witnessResultObj = totalRepList.filter(
          (i) => i.witness === true
        )[0];

        if (witnessResultObj) {
          setWitnessRep(witnessResultObj);
        } else {
          // IMPORTANT: The witness was deleted! Clear state & clear error so no popup happens
          setWitnessRep(undefined);
          setEmailError("");

          let clearWitnessObj = {
            update: "clearAll",
            value: "",
            reportGuid: currentReportGUIDFromUrl
          };
          await axios
            .post(
              "/annualReport/updateWitness",
              clearWitnessObj,
              userSessionAuthKeyReturnValue
            )
            .catch((e) => console.log(e));
        }

        toast.current.show({
          severity: "error",
          summary: TranslationFile.DeletedText[userSelectedLanguage],
          detail: TranslationFile.RepdeleteSucess[userSelectedLanguage],
          life: 3000
        });
      } catch (error) {
        console.error("Error deleting rows:", error);
      }

      setDeleteRep(emptyProduct);

      setSelectedProducts(null);
    }
  };

  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label={TranslationFile.noBtn[userSelectedLanguage]}
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label={TranslationFile.yesBtn[userSelectedLanguage]}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );

  const repFirstNameOnBlur = (e) => {
    let firstName = e.target.value;
    if (firstName != "" && firstName.length < 2) setRepFirstNameBlurError(true);
    else setRepFirstNameBlurError(false);
  };

  const repLastNameOnBlur = (e) => {
    let lastName = e.target.value;
    if (lastName != "" && lastName.length < 2) setRepLastNameBlurError(true);
    else setRepLastNameBlurError(false);
  };

  const languageValue = (e) => {};

  // const callback = (annualReport, session, link, status) => {
  //   if (status) {
  //     history.push(annualReport + session + link);
  //   }
  // };
  const callback = (annualReport, session, link, status) => {
    let sessionFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      history.push(annualReport + sessionFromLS + link);
    }
    setRender(!render);
  };
  const CityOnBlur = () => {
    if (userSessionAuthKeyReturnValue) {
      let updateCityObject = {
        city: cityValue,
        reportID: reportIDFromDB
      };
      axios
        .post(
          "/annualReportRepresentative/updateCity",
          updateCityObject,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (!response.data) {
            toast.current.show({
              severity: "info",
              summary: "Info",
              detail:
                TranslationFile.repToast2[userSelectedLanguage] +
                TranslationFile.cityRepToast[userSelectedLanguage],
              life: 3000
            });
            checkAccessablePages();
          }
        });
    }
  };

  const dateOnBlur = (e) => {
    if (calendarHardCodedDate != "") {
      if (calendarHardCodedDate.length == 6) {
        var year = calendarHardCodedDate.substr(0, 2);
        var month = calendarHardCodedDate.substr(2, 2);
        var date = calendarHardCodedDate.substr(4, 4);
        var newdate = "20" + year;
        newdate = newdate + "-" + month + "-" + date;
        dateValue = new Date(newdate);
      } else if (calendarHardCodedDate.length == 8) {
        if (calendarHardCodedDate.includes("-")) {
          let splittedFormat = calendarHardCodedDate.split("-");
          var year = "20" + splittedFormat[0];
          var month = splittedFormat[1];
          var date = splittedFormat[2];
          var newdate = year + "-" + month + "-" + date;

          dateValue = new Date(newdate);
        } else {
          var year = calendarHardCodedDate.substr(0, 4);
          var month = calendarHardCodedDate.substr(4, 2);
          var date = calendarHardCodedDate.substr(6, 5);
          var newdate = year;
          newdate = newdate + "-" + month + "-" + date;
          dateValue = new Date(newdate);
        }
      }
      setRepDate(dateValue);
      if (dateValue != "") {
        insertDateInForRep(dateValue, "dateKeyIn");
      }
    }
  };

  const insertDateInForRep = (e, type) => {
    if (userSessionAuthKeyReturnValue) {
      let originalDateFormat = "";
      if (type == "dateKeyIn") {
        originalDateFormat = e;
      } else {
        originalDateFormat = e.target.value;
      }
      let StandardDateFormat = moment(originalDateFormat).format("YYYY-MM-DD");

      const date = new Date(StandardDateFormat);
      const unixTimestamp = Math.floor(date.getTime());
      //  const unixTimestamp = (new Date(StandardDateFormat)).getTime();
      let updateDateObject = {
        date: unixTimestamp,
        reportID: reportIDFromDB
      };

      // Insert & Update Representative Date
      axios
        .post(
          "/annualReportRepresentative/updateDate",
          updateDateObject,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {});
    }
  };
  const dateOnChange = (e) => {
    if (e.target.value != null) {
      setRepDate(e.target.value);
      if (e.target.value != null) {
        insertDateInForRep(e, "datePick");
      }
    } else {
      dataKeyIn = dataKeyIn + "" + e.originalEvent.nativeEvent.data;
      dataKeyIn = dataKeyIn.replace("null", "");
      setCalendarHardCodedDate(dataKeyIn);
    }
  };

  const sideBarStatusFnc = (e) => {
    setSideBarStatus(e);
  };

  const addRepRoleOnChange = (e) => {
    setRepRole(e);
  };

  const signTypeOnChange = (e) => {
    setSignType(e);
  };

  const sideBarCallback = (value) => {
    if (value) {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 3000
      });
    }
  };

  const tourStatus = (e) => {
    setRun(e);
  };

  const emailIdOnChange = (e) => {
    setWitnessRep((prev) => ({
      ...prev,
      emailId: e
    }));
  };

  const emailIdOnBlur = (e) => {
    if (!validateEmail(e)) {
      setEmailError(TranslationFile.invalidEmailAddress[userSelectedLanguage]);
    } else {
      setEmailError("");

      let obj = {
        update: "emailId",
        value: e,
        reportGuid: currentReportGUIDFromUrl
      };
      axios
        .post("/annualReport/updateWitness", obj, userSessionAuthKeyReturnValue)

        .then((response) => {
          if (response.data) {
          }
        });
    }
    checkAccessablePages();
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <Joyride
        continuous
        run={run}
        disableBeacon={true}
        showProgress={false}
        showSkipButton
        steps={steps}
        scrollToFirstStep
        scrollToSteps={true}
        disableScrolling={false}
        scrollOffset={100}
        styles={{
          options: {
            zIndex: 10000
          }
        }}
      />

      {accessLevel == 4 ? (
        <NoAccess />
      ) : (
        <>
          <NavBarHeader
            callBack={callback}
            isAppPortal={true}
            isHomePage={false}
          />

          <div className="representative-sidebar-div">
            <Sidebar
              children="Representative"
              sideBarStatus={(e) => sideBarStatusFnc(e)}
              sideBarCallback={(e) => sideBarCallback(e)}
              tourStatus={tourStatus}
            />
          </div>
          <Toast ref={toast} style={{ marginTop: "34%" }} />
          <Row
            className={sideBarStatus ? "BSFYStyleRep" : "BSFYStyleRepSidebar"}
          >
            <Col>
              <div>
                <div className="Page_Title_rep">
                  <div className="Page_Title_T1_rep_name">{companyName}</div>
                  <div className="Page_Title_Rep_Year">
                    {currentFinancialYear}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              className={
                sideBarStatus
                  ? "pdf_view_col"
                  : " pdf_view_col pdf_view_col_sidebar"
              }
            >
              <div
                style={{
                  textAlign: "end",
                  marginTop: "12px",
                  marginBottom: "12px"
                }}
              >
                {/* <Button
              type="button"
              icon="pi pi-file-pdf"
              outlined
              style={{ borderRadius: "70px" }}
              className="pdf_view_rep"
              tooltip={TranslationFile.pdfPreview[userSelectedLanguage]}
              tooltipOptions={{ position: "bottom" }}
              onClick={() => previewPdfLocal(currentReportGUIDFromUrl)}

              // onClick={() => previewPdf(currentReportGUIDFromUrl)}
            /> */}

                <PreviewPdfHeader reportGuid={currentReportGUIDFromUrl} />
              </div>
            </Col>
          </Row>

          {pageLoading ? (
            <div className="repPageLoadingDiv">
              <center>
                <ProgressSpinner
                  style={{
                    width: "50px",
                    height: "40px",
                    top: "118px"
                  }}
                  className="repPageLoading"
                />
              </center>
            </div>
          ) : (
            <div className={sideBarStatus ? "rep-div" : "rep-div-sidebar"}>
              <Row style={{ width: "100%" }}>
                <br></br>

                <Col
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ width: "100%", marginLeft: "12px" }}
                >
                  <Accordion
                    multiple
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                    className="rep-accordion"
                  >
                    <AccordionTab
                      // className="rep-accordion-tab1"
                      header={
                        TranslationFile.representativeText[userSelectedLanguage]
                      }
                      className="IS-Accordion-Tab"
                    >
                      <div>
                        <center>
                          <div className="card-admin-page">
                            <Toolbar
                              className="admin-toolbar"
                              right={rightToolbarTemplate}
                              left={leftToolbarTemplate}
                            ></Toolbar>
                            <DataTable
                              disabled={linkSharedUser == 3}
                              ref={dt}
                              value={totalRepList}
                              editMode="row"
                              selection={selectedProducts}
                              onSelectionChange={(e) =>
                                setSelectedProducts(e.value)
                              }
                              selectionMode="checkbox"
                              dataKey="no"
                              emptyMessage={
                                TranslationFile.repEmptyMessage[
                                  userSelectedLanguage
                                ]
                              }
                              selectionPageOnly
                              className="representativeDataTable"
                            >
                              {reportAccess != 3 && (
                                <Column
                                  selectionMode="multiple"
                                  exportable={false}
                                  className="representative-checkbox"
                                  disabled={true}
                                ></Column>
                              )}

                              <Column
                                field="firstName"
                                header={
                                  TranslationFile.repFirstNameText[
                                    userSelectedLanguage
                                  ]
                                }
                                style={{ width: "20%" }}
                                className="representative-firstName"
                                editor={(options) => textEditorFName(options)}
                              ></Column>

                              <Column
                                field="lastName"
                                header={
                                  TranslationFile.repLastNameText[
                                    userSelectedLanguage
                                  ]
                                }
                                style={{ width: "20%" }}
                                className="representative-lastName"
                                editor={(options) => textEditorLName(options)}
                              ></Column>

                              <Column
                                field="sSN"
                                header={
                                  TranslationFile.repSocialNo[
                                    userSelectedLanguage
                                  ]
                                }
                                className="representative-SSN"
                                style={{ width: "20%" }}
                                editor={(options) => textEditorMask(options)}
                              ></Column>

                              <Column
                                field="role"
                                header={
                                  TranslationFile.repRole[userSelectedLanguage]
                                }
                                className="representative-role"
                                style={{ width: "20%" }}
                                body={roleBodyTemplate}
                                editor={(options) => roleEditor(options)}
                              ></Column>

                              {/* <Column
                            field="signType"
                            header={
                              TranslationFile.signTypeText[userSelectedLanguage]
                            }
                            className="representative-signType"
                            style={{ width: "20%" }}
                            body={signTypeBodyTemplate}
                            editor={(signTypeObj) =>
                              signTypeEditor(signTypeObj)
                            }
                          ></Column> */}

                              <Column
                                field="witness"
                                // header={
                                //   TranslationFile.signTypeText[userSelectedLanguage]
                                // }
                                header={
                                  TranslationFile.WitnessText[
                                    userSelectedLanguage
                                  ]
                                }
                                className="representative-signType"
                                style={{ width: "20%" }}
                                body={witnessBodyTemplate}
                                // editor={(signTypeObj) => signTypeEditor(signTypeObj)}
                              ></Column>

                              {reportAccess != 3 && (
                                <Column
                                  rowEditor
                                  headerStyle={{
                                    width: "20%",
                                    minWidth: "5rem"
                                  }}
                                  bodyStyle={{ textAlign: "center" }}
                                  className="representativeRowEdit"
                                ></Column>
                              )}
                            </DataTable>
                          </div>
                        </center>
                      </div>

                      <div className="rept-citydate">
                        <Row>
                          <Col className="rep-div-city">
                            <label className="rep-label-city">
                              {/* City  */}
                              {
                                TranslationFile.repCityText[
                                  userSelectedLanguage
                                ]
                              }
                              <p className="companyInformationMandatoryStart">
                                *
                              </p>
                            </label>
                            <InputText
                              className="rep-city-box"
                              value={cityValue}
                              onChange={(e) => setCityValue(e.target.value)}
                              onBlur={() => CityOnBlur()}
                              placeholder={
                                TranslationFile.repEnterCityText[
                                  userSelectedLanguage
                                ]
                              }
                              disabled={reportAccess == 3}
                            />
                          </Col>
                          <Col className="rep-div-date">
                            <label className="rep-label-date">
                              {TranslationFile.repDate[userSelectedLanguage]}
                              {/* Date */}
                              <p className="companyInformationMandatoryStart">
                                *
                              </p>
                            </label>
                            <Calendar
                              className="rep-date-box"
                              value={repDate}
                              onChange={(e) => dateOnChange(e)}
                              onBlur={(e) => dateOnBlur(e)}
                              showIcon
                              dateFormat="yy-mm-dd"
                              placeholder={
                                TranslationFile.YearFormat[userSelectedLanguage]
                              }
                              disabled={reportAccess == 3}
                              locale={localeLang}
                            />
                          </Col>
                        </Row>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Dialog
                    visible={addNewRepDialog}
                    style={{ width: "32rem" }}
                    breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                    header={TranslationFile.repAddNewRep[userSelectedLanguage]}
                    modal
                    className="p-fluid"
                    blockScroll
                    footer={addNewRepDialogFooter}
                    onHide={hideAddNewRep}
                    closeOnEscape={false}
                  >
                    <div className="field">
                      <p className="adminPageCompanyInfoEditPopUpTitles">
                        {/* First Name */}
                        {TranslationFile.repFirstNameText[userSelectedLanguage]}
                      </p>
                      <InputText
                        id="name"
                        value={repFirstName}
                        onChange={(e) => {
                          setRepFirstName(e.target.value);
                        }}
                        onBlur={(e) => repFirstNameOnBlur(e)}
                        required
                        autoFocus
                        placeholder={
                          TranslationFile.repFirstNameText[userSelectedLanguage]
                        }
                        className={classNames({
                          "p-invalid":
                            (newRepsubmitted && !repFirstName) ||
                            repFirstNameBlurError ||
                            repLastNameBlurError
                        })}
                      />
                      {newRepsubmitted && repFirstName == "" && (
                        <small className="p-error">
                          {/* First Name is required. */}
                          {
                            TranslationFile.repFirstNameReq[
                              userSelectedLanguage
                            ]
                          }
                        </small>
                      )}
                      {repFirstNameBlurError && (
                        <small className="p-error">
                          {/* First Name requires minimum 2 letters. */}
                          {
                            TranslationFile.repFirstNameMini2Letter[
                              userSelectedLanguage
                            ]
                          }
                        </small>
                      )}
                    </div>

                    <br></br>

                    <div className="field">
                      <p className="adminPageCompanyInfoEditPopUpTitles">
                        {TranslationFile.repLastNameText[userSelectedLanguage]}
                        {/* Last Name */}
                      </p>
                      <InputText
                        value={repLastName}
                        onChange={(e) => {
                          setRepLastName(e.target.value);
                        }}
                        onBlur={(e) => repLastNameOnBlur(e)}
                        required
                        placeholder={
                          TranslationFile.repLastNameText[userSelectedLanguage]
                        }
                        className={classNames({
                          "p-invalid": newRepsubmitted && !repLastName
                        })}
                      />
                      {newRepsubmitted && !repLastName && (
                        <small className="p-error">
                          {/* Last Name is required. */}
                          {TranslationFile.repLastNameReq[userSelectedLanguage]}
                        </small>
                      )}
                      {repLastNameBlurError && (
                        <small className="p-error">
                          {/* First Name requires minimum 2 letters. */}
                          {
                            TranslationFile.repFirstNameMini2Letter[
                              userSelectedLanguage
                            ]
                          }
                        </small>
                      )}
                    </div>

                    <br></br>

                    <div className="field">
                      <p className="adminPageCompanyInfoEditPopUpTitles">
                        {/* Social Security No. */}
                        {TranslationFile.repSocialNo[userSelectedLanguage]}
                      </p>
                      <InputMask
                        useGrouping={false}
                        value={repSSN}
                        mask="99999999-9999"
                        onChange={(e) => {
                          setRepSSN(e.value);
                        }}
                        required
                        placeholder={
                          TranslationFile.SSNFormat[userSelectedLanguage]
                        }
                        // style={{ borderColor: repSsnBlurError && "red" }}
                      />
                      {newRepsubmitted &&
                        repSSN == "" &&
                        signType.code == 1 && (
                          <small className="p-error">
                            {TranslationFile.repSsnReq[userSelectedLanguage]}
                          </small>
                        )}
                    </div>

                    <br></br>
                    <div className="field">
                      <p className="adminPageCompanyInfoEditPopUpTitles">
                        {TranslationFile.repRole[userSelectedLanguage]}
                      </p>
                      <Dropdown
                        id="rep_Dropdown_list"
                        value={repRole}
                        options={repRoleOptionsObj}
                        onChange={(e) => {
                          addRepRoleOnChange(e.value);
                        }}
                        optionLabel="name"
                        // editable
                        placeholder={
                          TranslationFile.repSelectRoll[userSelectedLanguage]
                        }
                      />
                      {newRepsubmitted && repRole == "" && (
                        <small className="p-error">
                          {TranslationFile.repRoleReq[userSelectedLanguage]}
                        </small>
                      )}
                    </div>
                    <br></br>

                    {/* //SignType */}

                    {/* <div className="field">
                  <p className="adminPageCompanyInfoEditPopUpTitles">
                    {TranslationFile.signTypeText[userSelectedLanguage]}
                  </p>
                  <Dropdown
                    id="signType_Dropdown_list"
                    value={signType}
                    options={signTypeObj}
                    onChange={(e) => {
                      signTypeOnChange(e.value);
                    }}
                    optionLabel="name"
                  />
                </div> */}
                  </Dialog>

                  <Dialog
                    visible={deleteProductDialog}
                    style={{
                      width: "32rem"
                    }}
                    breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                    header={
                      TranslationFile.dashboardConfirmBtn[userSelectedLanguage]
                    }
                    blockScroll
                    modal
                    footer={deleteProductDialogFooter}
                    onHide={hideDeleteProductDialog}
                  >
                    <div className="confirmation-content">
                      <i
                        className="pi pi-exclamation-triangle mr-3"
                        style={{ fontSize: "2rem", color: "#ff5f00" }}
                      />
                      {selectedProducts && (
                        <span>
                          {/* Are you sure you want to delete  */}
                          {
                            TranslationFile.repConfDeleteText1[
                              userSelectedLanguage
                            ]
                          }
                          <b></b>?
                        </span>
                      )}
                    </div>
                  </Dialog>

                  <Dialog
                    visible={deleteProductsDialog}
                    style={{ width: "32rem" }}
                    breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                    header={
                      TranslationFile.dashboardConfirmBtn[userSelectedLanguage]
                    }
                    blockScroll
                    modal
                    footer={deleteProductDialogFooter}
                    onHide={hideDeleteProductsDialog}
                  >
                    <div className="confirmation-content">
                      <div>
                        <span>
                          {
                            TranslationFile.repConfDeleteText2[
                              userSelectedLanguage
                            ]
                          }
                          {/* Are you sure you want to delete the selected report? */}
                        </span>
                      </div>
                    </div>
                  </Dialog>

                  <br />
                  <br />

                  <div>
                    <Fieldset
                      legend={TranslationFile.WitnessText[userSelectedLanguage]}
                    >
                      <Row className="upload-row">
                        <Col>
                          <label
                            htmlFor="Name"
                            className="companyInformationTextBoxTitle"
                          >
                            {TranslationFile.repSocialNo[userSelectedLanguage]}
                            <p className="companyInformationMandatoryStart">
                              *
                            </p>
                          </label>
                          <InputText
                            value={
                              witnessRep != undefined ? witnessRep.ssn : ""
                            }
                            // onChange={(e) => this.setState({ firstName: e.target.value })}
                            required
                            // placeholder={
                            //   TranslationFile.LoginFirstName[userSelectedLanguage]
                            // }
                            disabled
                          />
                        </Col>

                        <Col>
                          <label
                            htmlFor="Name"
                            className="companyInformationTextBoxTitle"
                          >
                            {
                              TranslationFile.LoginFirstName[
                                userSelectedLanguage
                              ]
                            }
                            <p className="companyInformationMandatoryStart">
                              *
                            </p>
                          </label>

                          <InputText
                            value={
                              witnessRep != undefined
                                ? witnessRep.firstName
                                : ""
                            }
                            // onChange={(e) => this.setState({ firstName: e.target.value })}
                            required
                            placeholder={
                              TranslationFile.LoginFirstName[
                                userSelectedLanguage
                              ]
                            }
                            disabled
                          />
                        </Col>

                        <Col>
                          <label
                            htmlFor="Name"
                            className="companyInformationTextBoxTitle"
                          >
                            {
                              TranslationFile.LoginLastName[
                                userSelectedLanguage
                              ]
                            }
                            <p className="companyInformationMandatoryStart">
                              *
                            </p>
                          </label>

                          <InputText
                            value={
                              witnessRep != undefined ? witnessRep.lastName : ""
                            }
                            // onChange={(e) => this.setState({ lastName: e.target.value })}
                            required
                            placeholder={
                              TranslationFile.LoginLastName[
                                userSelectedLanguage
                              ]
                            }
                            disabled
                          />
                        </Col>
                      </Row>

                      <Row className="upload-row">
                        <Col>
                          <label
                            htmlFor="Name"
                            className="companyInformationTextBoxTitle"
                          >
                            {TranslationFile.repRole[userSelectedLanguage]}
                            <p className="companyInformationMandatoryStart">
                              *
                            </p>
                          </label>

                          <InputText
                            value={
                              witnessRep != undefined ? witnessRep.role : ""
                            }
                            // onChange={(e) =>
                            //   this.setState({ designation: e.target.value })
                            // }
                            required
                            placeholder={
                              TranslationFile.repRole[userSelectedLanguage]
                            }
                            disabled
                          />
                        </Col>

                        <Col>
                          <label
                            htmlFor="Name"
                            className="companyInformationTextBoxTitle"
                          >
                            {TranslationFile.EmailIdText[userSelectedLanguage]}
                            <p className="companyInformationMandatoryStart">
                              *
                            </p>
                          </label>
                          <InputText
                            value={
                              witnessRep != undefined ? witnessRep.emailId : ""
                            }
                            onChange={(e) => emailIdOnChange(e.target.value)}
                            onBlur={(e) => emailIdOnBlur(e.target.value)}
                            required
                            placeholder={
                              TranslationFile.EmailIdText[userSelectedLanguage]
                            }
                            disabled={linkSharedUser == 3 ? true : false}
                          />
                          <div>
                            <i className="representativeExampleEmailIds">
                              (e.g.:email1@abc.com)
                            </i>
                          </div>

                          {emailError && (
                            <small style={{ color: "red" }}>{emailError}</small>
                          )}
                        </Col>
                      </Row>
                    </Fieldset>
                  </div>

                  <center className="MgmtSaveBtnCenter">
                    <Button
                      label={TranslationFile.previousBtn[userSelectedLanguage]}
                      aria-label={
                        TranslationFile.FooterAnnualReport[userSelectedLanguage]
                      }
                      onClick={() => navigationOnClick("managementStatement")}
                      id="annualReportBtn"
                      className="MgmtSaveBtn"
                    />
                    {cityValue != "" && repDate != "" && repDate != null ? (
                      <Button
                        label={TranslationFile.nextBtn[userSelectedLanguage]}
                        aria-label={
                          TranslationFile.FooterAnnualReport[
                            userSelectedLanguage
                          ]
                        }
                        onClick={() => navigationOnClick("Payment")}
                        id="annualReportBtn"
                        className="MgmtSaveBtn"
                        disabled={emailError == "" ? false : true}
                      />
                    ) : (
                      <Button
                        label={TranslationFile.nextBtn[userSelectedLanguage]}
                        aria-label={
                          TranslationFile.FooterAnnualReport[
                            userSelectedLanguage
                          ]
                        }
                        onClick={() => navigationOnClick("Payment")}
                        id="annualReportBtn"
                        className="MgmtSaveBtn"
                        disabled={emailError == "" ? true : false}
                      />
                    )}
                  </center>
                  {/*  <center className="MgmtSaveBtnCenter">
                    <Button
                      label={TranslationFile.previousBtn[userSelectedLanguage]}
                      aria-label={
                        TranslationFile.FooterAnnualReport[userSelectedLanguage]
                      }
                      onClick={() => navigationOnClick("managementStatement")}
                      id="annualReportBtn"
                      className="MgmtSaveBtn"
                    />
                    <Button
                      label={TranslationFile.nextBtn[userSelectedLanguage]}
                      aria-label={
                        TranslationFile.FooterAnnualReport[userSelectedLanguage]
                      }
                      onClick={() => navigationOnClick("Payment")}
                      id="annualReportBtn"
                      className="MgmtSaveBtn"
                      disabled={
                        cityValue === "" || repDate === "" || repDate === null
                      }
                    />
                  </center> */}
                </Col>
              </Row>
            </div>
          )}
          <ScrolltoTop />
          <Footer_contact_tab
            sideBar={sideBarStatus}
            isCorpPortal={false}
            isHomePage={true}
          />
          <Dialog
            visible={pdfLoading}
            style={{ width: "30vw" }}
            className="pdfDialogBox"
            blockScroll
            closable={false}
          >
            <div className="pdfLoading">
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "2rem" }}
              ></i>
            </div>
          </Dialog>

          <Dialog
            visible={witnessRoleDialogBox}
            style={{ width: "50vw" }}
            onHide={() => {
              if (!witnessRoleDialogBox) return;
              setWitnessRoleDialogBox(false);
            }}
          >
            <center>
              {" "}
              <p className="m-0">
                {TranslationFile.selectWitnessRole[userSelectedLanguage]}
                <br />
                <Dropdown
                  value={selectedWitnessRole}
                  onChange={(e) => witnessDropdownOnClick(e.value)}
                  options={witnessRepRole}
                  optionLabel="name"
                  placeholder={
                    TranslationFile.repRoleSelect[userSelectedLanguage]
                  }
                  className="witnessDialogBoxDropdown"
                />
              </p>
            </center>
          </Dialog>
        </>
      )}
    </div>
  );
}
